import { userLogout } from "@/services/rest/auth";
import { useMutation } from "@tanstack/react-query";

export const useUserLogout = () => {
  return useMutation({
    mutationKey: ["userLogout"],
    mutationFn: userLogout,
  });
};
